import { FilterComponentTypes } from '@features/Filters/const';
import { TActiveQuickFilter } from '@features/Filters/redux/types';

export enum FilterType {
  Date = 'Date',
  TextBox = 'TextBox',
  MoneyRange = 'MoneyRange',
  NumericRange = 'NumericRange',
  CheckBoxList = 'CheckBoxList',
  CheckBoxTreeList = 'CheckBoxTreeList',
  CategoryFilter = 'CategoryFilter'
}

export type TFilterValues = TRangeValues | TTextBoxValues | TDateValues | TCheckBoxListValues;

export type TFilter = {
  defaultValues: TFilterValues;
  displayName: string;
  filterTypeName: FilterType;
  groupDisplayName: string;
  internalName: string;
  isAutoComplete: boolean;
  systemDefaultChecked: boolean;
  isInnerCategory?: boolean;
};

export type TSort = {
  displayName: string;
  sortColumn: string;
  sortDir: number;
};

export type TFailedCount = {
  count: number;
  internalName: string;
};

export type TCurrentSort = {
  sortColumn: string;
  sortDir: number;
};

export type TFilters = {
  filterItems: TFilter[];
  sortItems: TSort[];
};

export type TRangeValues = [
  {
    title: string;
    value: number;
  },
  {
    title: string;
    value: number;
  }
];

export type TTextBoxValues = [];

export type TDateValues = [];

export type TCheckBoxListValues = TCheckBoxListValue[];

export type TCheckBoxListValue = {
  title: string;
  value: number;
};

export type TCurrentFilter = { internalName: string; values: TCurrentFilterValue };
export type TCurrentFilterValue = TCurrentFilterRangeValue | TCurrentFilterTextBoxValue | TCurrentCheckboxListValue;
export type TCurrentFilterRangeValue = [number, number];
export type TCurrentFilterTextBoxValue = string[];
export type TCurrentCheckboxListValue = number[];

export type TCurrentTextBox = {
  internalName: string;
  inputValue: string;
  values: TCurrentTextBoxValue[];
};
export type TCurrentTextBoxValue = { title: string; value: string };

export type TCurrentTextBoxIsLoadingState = { internalName: string; isLoading: boolean };

export type TCurrentDateValue = [string, string];
export type TDatepickerYearsSliderDirection = 'left' | 'right';

export type TFilterTag = { name: string; internalName: string; type: FilterType };

export type TCheckboxRequest = {
  requestURL: string;
  requestPage: string;
};

export type TSetFilterData = {
  newFilterItem: TCurrentFilter;
  type?: FilterComponentTypes;
};

export type TClearFilterData = {
  filterInternalName: string;
  type?: FilterComponentTypes;
};

export type TClearCurrentTextBoxValues = {
  textBoxItems: string[];
  type?: FilterComponentTypes;
};

export type TSuccessTextBoxFilterData = {
  currentTextBox: TCurrentTextBox;
  type?: FilterComponentTypes;
};

export type TActiveQuickFilterData = {
  activeQuickFilter: TActiveQuickFilter;
  type?: FilterComponentTypes;
};

export type TSetCurrentTextBoxIsLoading = TCurrentTextBoxIsLoadingState & { type?: FilterComponentTypes };

export type TSetFilterItems = {
  filterItems: TFilter[];
  type?: FilterComponentTypes;
};

export type TSetSortItemsData = {
  sortItems: TSort[];
  type?: FilterComponentTypes;
};

export type TSetCurrentSortItem = {
  newSortItem: TSort;
  type?: FilterComponentTypes;
};

export type TGroupedFilter = {
  group: string;
  items: TFilter[];
  order: number;
};
